import React, { useRef } from "react";
import jcb from "../../Assets/jcb.jpg";
import { GiPlainSquare } from "react-icons/gi";
import { MdArrowOutward } from "react-icons/md";
import email from "@emailjs/browser";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    // Replace these with your actual IDs from EmailJS
    const YOUR_SERVICE_ID = "service_r5stwyx";
    const YOUR_TEMPLATE_ID = "template_4y2id9w";
    const YOUR_PUBLIC_KEY = "_axDHmowmzWYqdyjc";

    email
      .sendForm(YOUR_SERVICE_ID, YOUR_TEMPLATE_ID, form.current, {
        publicKey: YOUR_PUBLIC_KEY,
      })
      .then(
        () => {
          console.log("SUCCESS!");
          alert("Message sent successfully!");
          e.target.reset(); // Clears the form after sending
        },
        (error) => {
          console.log("FAILED...", error.text);
          alert("Failed to send message. Please try again.");
        }
      );
  };

  return (
    <div className="flex flex-col sm:flex-row max-w-screen-2xl mx-auto">
      {/* Left Section: Image */}
      <div className="w-full sm:w-1/2">
        <img
          src={jcb}
          alt="jcb"
          className="h-[300px] sm:h-[510px] w-full object-cover"
        />
      </div>

      {/* Right Section: Contact Form */}
      <div className="w-full sm:w-1/2 space-y-4 py-8 px-4 sm:px-8 bg-[#1e2023]">
        {/* Header */}
        <div className="flex justify-start space-x-2">
          <GiPlainSquare className="text-[#068b07]" size={12} />
          <p className="text-gray-400 -mt-0.5 font-medium text-xs">
            LET'S WORK TOGETHER
          </p>
        </div>
        <h1 className="text-2xl sm:text-3xl text-white font-semibold">
          Get In Touch With Us
        </h1>
        <p className="text-gray-100 text-xs sm:text-sm">
          If you need to repair or replace your Plumbing system, call today and
          talk to one of our Plumbing specialists.
        </p>

        {/* Contact Form */}
        <form
          ref={form}
          onSubmit={sendEmail}
          className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4"
        >
          <input
            type="text"
            name="first_name"
            required
            placeholder="First Name"
            className="w-full p-2 border border-gray-500 bg-transparent text-white"
          />
          <input
            type="text"
            name="last_name"
            required
            placeholder="Last Name"
            className="w-full p-2 border border-gray-500 bg-transparent text-white"
          />
          <input
            type="tel"
            name="phone"
            placeholder="Mobile Number"
            className="w-full p-2 border border-gray-500 bg-transparent text-white"
          />
          <input
            type="email"
            name="user_email"
            required
            placeholder="Email"
            className="w-full p-2 border border-gray-500 bg-transparent text-white"
          />
          <textarea
            name="message"
            required
            placeholder="Message"
            className="col-span-2 w-full p-2 border border-gray-500 bg-transparent text-white h-24"
          />
          <button
            type="submit"
            className="flex col-span-2 gap-4 bg-[#068b07] text-white font-medium justify-center px-4 py-2 mb-3 cursor-pointer hover:bg-[#057a06] transition-colors"
          >
            <span className="pt-1">SUBMIT</span>
            <MdArrowOutward className="bg-[#121315] text-white p-1" size={32} />
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
